<template>
  <div class="create-layer-control-container"
    :style="{
      '--buttonColor': buttonColor,
      '--hoverFill': hoverFill,
    }"
  >
    <el-button v-for="(btn, index) of buttonList"
      :key="index"
      :icon="getIcon(btn)"
      :title="btn.name"
      @click="btn.onClick(btn)"
      text
      :class="{
        'btn-hover': btn[hoverProp],
      }"
    ></el-button>

    <el-popover
      placement="bottom"
      trigger="hover"
      effect="dark"
      v-if="!isOffline"
      popper-class="exposure-legend-popover"
    >
      <template #default>
        <!-- <el-text v-show="todayExposureLegendList.length == 0" type="info">无数据</el-text>
        <el-checkbox v-for="(check, index) of todayExposureLegendList"
          :key="index"
          :label="check['type']"
          :checked="!exposureNoShowList.includes(check['type'])"
          @change="check && check.fn($event)"
          size="small"
          :style="
            check['color']?{
              '--color': check['color'],
            }:{}
          "
        ></el-checkbox> -->
        <el-text v-show="todayExposureLegendMap.size == 0" type="info">无数据</el-text>
        <div class="exposure-legend-row" v-for="[type, controls, index] in todayExposureLegendMap">
          <!-- :label="type" -->
          <el-checkbox
            v-for="(check, cIndex) of controls"
            :key="cIndex"
            :checked="!exposureNoShowList.includes(type)"
            @change="check && check.fn && check.fn($event)"
            size="small"
            :style="
              check['color']?{
                '--color': check['color'],
              }:{}
            "
          ></el-checkbox>
          <span >{{ type }}</span>
        </div>
      </template>
      <template #reference>
        <el-button
          text
          title="线索区"
          :icon="getIcon({
            icon: 'camera',
          })"
          :class="{
            'btn-hover': todayExposureShowFlag,
          }"
          @click="todayExposureShowFlagChange"
        ></el-button>
      </template>
    </el-popover>
    <el-popover
      placement="bottom"
      trigger="hover"
      effect="dark"
      v-if="isWorkMode"
    >
      <template #default>
        <el-button
          type="primary" size="small"
          @click="districtRecFn5"
        >5×5 km²</el-button>
        <el-button
          type="primary" size="small"
          @click="districtRecFn25"
        >25×25 km²</el-button>
      </template>
      <template #reference>
        <el-button
          text
          title="影像"
          :icon="getIcon({
            icon: 'image',
          })"
        ></el-button>
      </template>
    </el-popover>
    <el-popover
      placement="bottom"
      trigger="click"
      effect="dark"
      v-if="tileList.length > 0"
    >
      <template #default>
        <el-radio-group v-model="tileVal" size="small"
          @change="radioChange"
        >
          <!-- <el-radio-button :value="index" border
            v-for="(tile, index) of tileList"
            :key="index"
          >{{ tile['name'] }}</el-radio-button> -->
          <el-space direction="vertical"
            :style="{
              'align-items': 'normal',
            }"
          >
            <el-radio :value="index" border
              v-for="(tile, index) of tileList"
              :key="index"
            >
              <template #default>{{ tile['name'] }}</template>
            </el-radio>
          </el-space>
        </el-radio-group>
      </template>
      <template #reference>
        <el-button
          text
          title="底图"
          :icon="getIcon({
            icon: 'map-baseSelect',
          })"
        ></el-button>
      </template>
    </el-popover>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from "@/store";
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';
import { districtRecFn } from '@/utils/js/recDistrictUtil';

import SvgIcon from '@/components/SvgIcon';
import TextEdit from './TextEdit';

import * as turf from '@turf/turf'

import {
  queryFixedBaseMap,
} from '@/api/UserWorkspaceDataApi';

import { mapBaseLayers, } from '@/utils/js/leafletUtils';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);
const isOffline = __IS__OFFLINE__;

const homeMap = computed(()=> store.getters.getHomeMap ),
  map = toRaw(homeMap.value),
  layerGroup = L.featureGroup().addTo(map),
  layerGroupClose = ()=>{
    map.removeLayer(layerGroup);
  }

const isWorkMode = computed(()=> store.getters['isWorkMode']);

const recCreateFn = (width)=>{
  return (layer)=>{
    layer.options['width'] = width;
    map.fire(L.Draw.Event.DRAWSTOP, {
      layer: layer,
      layerType: 'imageRec',
    })
  }
}
// 自定义矩形区域
const districtRecFn5 = districtRecFn({
  map, layerGroup, clearFlag: false,
  createBeforeFn: recCreateFn(5),
});
const districtRecFn25 = districtRecFn({
  map, layerGroup, clearFlag: false,
  createBeforeFn: recCreateFn(25),
  width: 25,
});

// 线索区控制
const todayExposureShowFlag = computed(()=> store.getters['todayExposureShowFlag'] ),
      todayExposureShowFlagChange = (btn)=>{
        store.commit('todayExposureShowFlagChange', !todayExposureShowFlag.value);
        btn[hoverProp.value] = todayExposureShowFlag.value;
      }
// 线索区图例List { type, color, fn(flag) }
const exposureNoShowList = computed(()=> store.getters['exposureNoShowList']);
// 线索区图例 v1.0 现在用v2.0
const todayExposureLegendList = computed(()=> store.getters['todayExposureLegendList'] );
// 线索区图例 v2.0
const todayExposureLegendMap = computed(()=> store.getters['todayExposureLegendMap'] );

// 活动热图控制
const eventHeatMapShowFlag = computed(()=> store.getters['eventHeatMapShowFlag'] ),
      eventHeatMapShowFlagChange = (btn)=>{
        store.commit('eventHeatMapShowFlagChange', !eventHeatMapShowFlag.value);
        btn[hoverProp.value] = eventHeatMapShowFlag.value;
      }
// 持续跟踪 - 名录 控制
const regionDirectoryShowFlag = computed(()=> store.getters['regionDirectoryShowFlag'] ),
      regionDirectoryShowFlagChange = (btn)=>{
        store.commit('regionDirectoryShowFlagChange', !regionDirectoryShowFlag.value);
        btn[hoverProp.value] = regionDirectoryShowFlag.value;
      }

const tileList = ref([]), tileVal = ref(0), tileValChange = (val)=> tileVal.value = val;

const hoverProp = ref('isHover');

const mapEventInit = ()=>{
  map.on(L.Draw.Event.CREATED, event=>{
    const copyLayer = event.layer;
    let layer;
    // 点图层
    if(event.layerType == 'marker'){
      const icon = copyLayer['options']['icon'],
            layerType = icon['options']['layerType'];
        
      map.fire(L.Draw.Event.DRAWSTOP, {
        layer: copyLayer,
        layerType: layerType,
      })
      return;
    }
    // 多边形图层
    if(event.layerType == 'circle'){
      const latlng = copyLayer.getLatLng();
      const geojson = turf.circle([latlng.lng, latlng.lat], copyLayer.getRadius() / 1000, {
        steps: 64, units: 'kilometers',
      });
      L.geoJSON(geojson, {
        onEachFeature: (feature, l)=>{
          // console.log(feature, l);
          layer = l;
        }
      })
    }else{
      layer = event.layer;
    }
    map.fire(L.Draw.Event.DRAWSTOP, {
      layer: layer,
      layerType: 'polygon',
    })
  })
},
mapEventClose = ()=>{
  map.off(L.Draw.Event.CREATED);
}

const buttonColor = ref('rgb(34, 51, 102)');
const defaultFill = 'rgb(98, 119, 140)', hoverFill = ref('rgb(72, 131, 206)');
const getIcon = (item)=>{
  const { icon, fill } = item;
  return !icon?'':defineComponent({
    setup(){
      return ()=> h(SvgIcon, {
        iconName: icon,
        fillColor: fill || defaultFill,
      })
    }
  })
}

let drawControl,
    drawControlClear = ()=>{
      drawControl && drawControl.enabled();
    },
    drawControl_enable = ()=>{
      drawControl && drawControl.enable({});
    }

const squareInit = ()=>{
  drawControlClear();
  drawControl = new L.Draw.Rectangle(map, {});
  drawControl_enable();
}
const polygonInit = ()=>{
  drawControlClear();
  drawControl = new L.Draw.Polygon(map, {});
  drawControl_enable();
}
const circleInit = ()=>{
  drawControlClear();
  drawControl = new L.Draw.Circle(map, {});
  drawControl_enable();
}
import { getFileUploadIcon } from '@/components/FileUploadPopup/useFileUploadIcon';

// 自定义文件上传
const fileUploadFn = ()=>{
  drawControlClear();
  let icon = getFileUploadIcon({ layerType: 'fileUpload' });
  drawControl = new L.Draw.Marker(map, { icon, });
  // 原有的 enable 逻辑会内部挂载，因为这是绘制模式
  drawControl_enable();
}

// 文本
const customTextProp = store.getters['leafletPolygon/customTextProp'];

const textLayerClose = ()=>{
  map.getContainer().style.cursor = '';
  map.off('click', textLayerInit);
  map.off('contextmenu', textLayerClose);
}
const textLayerInit = (e)=>{
  // console.log(e);
  const { latlng } = e;
  try{
    const target = reactive({
      
    })

    const layer = L.marker(latlng, {
    })
    // 自定义文本dom
    const textApp = vueCreateAppInit(TextEdit, {
      target: target,
      layer: layer,
    });
    const textDiv = document.createElement("div");
    textApp.mount(textDiv);
    layer.setIcon(
      L.divIcon({
        html: textDiv,
        className: 'text-edit-container',
      })
    );
    // map.fire(L.Draw.Event.CREATED, { layer: layer, layerType: customTextProp });

  }catch (error) {
    console.log(error);
    textLayerClose();
  }
  textLayerClose();
}
const textCreateFn = (e)=>{
  if(map.getContainer().style.cursor == 'crosshair'){
    textLayerClose();
    return
  }
  map.getContainer().style.cursor = 'crosshair';
  map.on('click', textLayerInit);
  map.on('contextmenu', textLayerClose);
}
const editInit = ()=>{
  drawControl = new L.EditToolbar.Edit(map, {});
  drawControl_enable();
}
const buttonList = computed(()=>{
  return [
    // 编辑层按钮：选择底图后才显示
    isWorkMode.value?{
      name: '绘制一个矩形', icon: 'square', onClick: squareInit
    }:undefined,
    isWorkMode.value?{
      name: '绘制一个多边形', icon: 'polygon', onClick: polygonInit
    }:undefined,
    isWorkMode.value?{
      name: '绘制一个圆', icon: 'circle', onClick: circleInit,
    }:undefined,
    isWorkMode.value?{
      name: '视频上传', icon: 'file-upload', onClick: fileUploadFn,
    }:undefined,
    // 展示层按钮：始终可见
    !isOffline?
      reactive({ name: '活动热图', icon: 'heat-map', onClick: eventHeatMapShowFlagChange,
        [hoverProp.value]: eventHeatMapShowFlag.value
      }):undefined,
    !isOffline?
      reactive({ name: '持续跟踪', icon: 'osm', onClick: regionDirectoryShowFlagChange,
        [hoverProp.value]: regionDirectoryShowFlag.value
      }):undefined,
  ].filter(e=> e);
})

const defaultTileLayer = L.tileLayer(),
      defaultTileLayerAdd = ()=>{
        if(tileVal.value === undefined)tileValChange(0);
        if(
          !map.hasLayer(defaultTileLayer)
          && defaultTileLayer._url
          // && !isWorkMode.value
        ){
          map.addLayer(defaultTileLayer);
        }
      },
      defaultTileLayerClear = ()=>{
        tileValChange(undefined);
        if(map.hasLayer(defaultTileLayer)){
          map.removeLayer(defaultTileLayer);
        }
      }

const radioChange = (val)=>{
  const tile = tileList.value.at(val);
  tile['url'] && defaultTileLayer.setUrl(tile['url']);
  defaultTileLayerAdd();
}
// 进入/退出 工作模式（isWorkMode 已在上方定义）
watch(isWorkMode, (newd, old)=>{
  // console.log(newd, old);
  if(newd){
    defaultTileLayerClear();
  }else{
    defaultTileLayerAdd();
  }
}, {
  immediate: true,
})

const tileLayerProp = 'tileLayer';
const tileInit = (list)=>{
  radioChange(tileVal.value);
}

const queryFixedBaseMapFn = ()=>{
  queryFixedBaseMap({}).then(res=>{
    if(res.data.code == 1004){
      tileList.value = res.data.array;
      tileInit(tileList.value);
    }
  }).catch(err=>{
    console.log(err);
  });
}

const offlineBaseMapInit = ()=>{
  tileList.value.push({
    name: '自适应卫星底图',
    url: 'http://21.145.208.119:9312/map/osm_map/{z}/{x}/{y}.png'
  })
  tileInit(tileList.value);
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  mapEventInit();
  if(isOffline){
    offlineBaseMapInit();
  }else{
    queryFixedBaseMapFn();
  }
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  drawControlClear();
  mapEventClose();
  defaultTileLayerClear();
});

</script>

<style lang='less'>
// 曝光图例
.exposure-legend-popover{
  display: flex;
  flex-direction: column;
  .el-checkbox{
    margin: 0;
    .el-checkbox__input.is-checked .el-checkbox__inner{
      background-color: var(--color, var(--el-checkbox-checked-bg-color));
      --el-checkbox-checked-input-border-color: var(--color);
      // border: var(--color, var(--el-checkbox-checked-input-border-color)) !important;
    }
    .el-checkbox__label{
      color: var(--color, var(--el-checkbox-checked-text-color));
    }
    .el-checkbox__inner{
      border-color: var(--color);
    }
  }
  .exposure-legend-row{
    display: flex;
    gap: 5px;
    align-items: center;
    span{
      color: var(--fontCheckColor);
    }
  }
}
.create-layer-control-container{
  .el-button+.el-button{
    margin-left: 0px;
  }
  --iconSize: 20px;
  .el-button{
    padding: 5px;
    height: auto;
    .el-icon{
      width: var(--iconSize);
      height: var(--iconSize);
    }
  }
  .el-button.is-text:not(.is-disabled){
    &:hover{
      background-color: var(--buttonColor);
      .svg-icon{
        fill: var(--hoverFill) !important;
      }
    }
  }
  .btn-hover{
    background-color: var(--buttonColor);
    .svg-icon{
      fill: var(--hoverFill) !important;
    }
  }
}

</style>

<style lang='less' scoped>
.create-layer-control-container{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
</style>